import { Action } from '@ngrx/store';

export enum MarkReadStatusActionTypes {
  MarkAsRead = '[MarkReadStatus] Mark as read',
  MarkAsUnread = '[MarkReadStatus] Mark as unread',
  MarkReadStatusFail = '[MarkReadStatus] Mark read status change fail'
}

export class MarkAsRead implements Action {
  readonly type = MarkReadStatusActionTypes.MarkAsRead;
}

export class MarkAsUnread implements Action {
  readonly type = MarkReadStatusActionTypes.MarkAsUnread;
}

export class MarkAsReadFail implements Action {
  readonly type = MarkReadStatusActionTypes.MarkReadStatusFail;

  constructor(public payload: Error) {
  }
}

export type MarkReadStatusActions = MarkAsRead | MarkAsUnread;
